import { createReducer, createSelector, on } from "@ngrx/store";
import { loginFailure, loginSuccess, logout, logoutSuccess } from "./authentication.actions";
import dayjs from "dayjs";

export interface IAuthenticationState {
  isAuthenticated: boolean;
  nextWellnessCheck: Date | null;
  loginErrorMessage: string;
}

export const initialAuthenticationState: IAuthenticationState = {
  isAuthenticated: false,
  nextWellnessCheck: null,
  loginErrorMessage: ''
};

export const authenticationReducer = createReducer(
  initialAuthenticationState,
  // Add action handlers here
  on(loginSuccess, (state) => {
    return {
      ...state,
      isAuthenticated: true,
      nextWellnessCheck: dayjs().add(1, 'minute').toDate() // Set the next wellness check to 1 minute from now
    }
  }),
  on(logoutSuccess, (state) => {
    return {
      ...state,
      isAuthenticated: false,
      nextWellnessCheck: null
    }
  }),
  on(loginFailure, (state, action) => {
    return {
      ...state,
      loginErrorMessage: action.error
    }
  }),
)

export const selectAuthenticationState = (state: any): IAuthenticationState => state.AuthenticationState;

export const selectIsAuthenticated = createSelector(
  selectAuthenticationState,
  (state) => state.isAuthenticated
)

export const selectNeedsReauthentication = createSelector(
  selectAuthenticationState,
  (state) => {
    if (!state.isAuthenticated) {
      return true;
    } else {
      return dayjs().isAfter(dayjs(state.nextWellnessCheck));
    }
  }
);

export const selectLoginErrorMessage = createSelector(
  selectAuthenticationState,
  (state) => state.loginErrorMessage
)
